import React, { useState, useEffect, useContext } from "react";
import { parseCookies } from 'nookies';
import AppContext from "../../store/app-context";
import RFQHomeNewBrand from "./RFQHomeNewBrand";
import RFQHome from "./RFQHome";

const RFQHomeSelector = () => {
  const appCtx = useContext(AppContext);
  const cookies = parseCookies();

  const [newBrandStyle, setNewBrandStyle] = useState(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const isNewBrand = cookies?.rebrandEnabled ?? appCtx?.envProp?.react_app_new_brand_style;
    setNewBrandStyle(isNewBrand);
    setMounted(true);
  }, [appCtx.envProp.react_app_new_brand_style]);

  if (!mounted) return null;

  return newBrandStyle === 'true' ? <RFQHomeNewBrand /> : <RFQHome />;
};

export default RFQHomeSelector;